"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _taggedTemplateLiteral2 = require("babel-runtime/helpers/taggedTemplateLiteral");

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(["\n\tdisplay: flex;\n\twidth: 100%:\n\theight: 100%;\n\tmin-height: 200px;\n\tborder-radius: 0.5em;\n\tborder: 2px dashed ", ";\n\talign-items: center;\n\tjustify-content: center;\n\ttext-align: center;\n\ttransition: 0.2s border-color linear;\n"], ["\n\tdisplay: flex;\n\twidth: 100%:\n\theight: 100%;\n\tmin-height: 200px;\n\tborder-radius: 0.5em;\n\tborder: 2px dashed ", ";\n\talign-items: center;\n\tjustify-content: center;\n\ttext-align: center;\n\ttransition: 0.2s border-color linear;\n"]),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(["\n\tfont-size: 1em;\n\twidth: 50%;\n"], ["\n\tfont-size: 1em;\n\twidth: 50%;\n"]),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(["\n\twidth: 20%;\n\tpadding-top: 20%;\n\tbackground-image: url(", ");\n\tbackground-size: cover;\n\tbackground-position: center;\n"], ["\n\twidth: 20%;\n\tpadding-top: 20%;\n\tbackground-image: url(", ");\n\tbackground-size: cover;\n\tbackground-position: center;\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _reactDropzone = require("react-dropzone");

var _reactDropzone2 = _interopRequireDefault(_reactDropzone);

var _superagent = require("superagent");

var _superagent2 = _interopRequireDefault(_superagent);

var _recompose = require("recompose");

var _button = require("./button");

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// --------------------------------------------------

var enhance = (0, _recompose.compose)((0, _recompose.withHandlers)({
	onDrop: function onDrop(props) {
		return function (_ref) {
			var _ref2 = (0, _slicedToArray3.default)(_ref, 1),
			    file = _ref2[0];

			if (props.onDropFile) {
				props.onDropFile(file);
			}

			if (props.uploadUrl) {
				return _superagent2.default.post(props.uploadUrl).field("file", file).end(function (err, resp) {
					(!err && resp ? Promise.resolve(resp) : Promise.reject(err || resp)).then(props.onUpload || _ramda2.default.identity).then(function () {
						return window.URL.revokeObjectURL(file.preview);
					}).catch(props.onFail || _ramda2.default.identity);
				});
			} else {
				return Promise.reject("props.uploadUrl required");
			}
		};
	}
}));

var DropzoneWrapper = _styledComponents2.default.div(_templateObject, function (props) {
	return props.active ? props.theme.colors.blue : props.theme.colors.lightGrey;
});

var DropzoneText = _styledComponents2.default.div(_templateObject2);

var DropzoneImagePreview = _styledComponents2.default.div(_templateObject3, _ramda2.default.prop("src"));

// props: { isDragActive, isDragReject, acceptedFiles, rejectedFiles }
var DropzoneContent = function DropzoneContent(props) {
	if (props.acceptedFiles.length) {
		return _react2.default.createElement(
			DropzoneWrapper,
			{ active: true },
			_react2.default.createElement(DropzoneImagePreview, { src: props.acceptedFiles[0].preview }),
			_react2.default.createElement(
				DropzoneText,
				null,
				"Uploading..."
			)
		);
	} else if (props.isDragActive) {
		return _react2.default.createElement(
			DropzoneWrapper,
			{ active: true },
			_react2.default.createElement(
				DropzoneText,
				null,
				"drop your file here!"
			)
		);
	} else {
		return _react2.default.createElement(
			DropzoneWrapper,
			null,
			_react2.default.createElement(
				DropzoneText,
				null,
				"drag files here or"
			),
			_react2.default.createElement(
				_button2.default,
				{ type: "CONFIRM" },
				"Choose a file"
			)
		);
	}
};

var Uploader = function Uploader(props) {
	return _react2.default.createElement(
		_reactDropzone2.default,
		{
			onDrop: props.onDrop,
			style: {
				width: "100%",
				height: "100%",
				minHeight: "200px"
			}
		},
		DropzoneContent
	);
};

exports.default = enhance(Uploader);

//# sourceMappingURL=genericUploader.js.map


//////////////////
// WEBPACK FOOTER
// ./~/codogo-react-widgets/dist/components/genericUploader.js
// module id = 372
// module chunks = 0